// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  IAssessmentSupportDocumentGetListAttrs,
  IAssessmentSupportDocumentDownloadDocumentAttrs,
} from 'interfaces/back-office/assessment/support-document/support-document-view.interface'

const useAssessmentSupportDocument = () => {
  // Hook
  const {
    assessmentSupportDocument: {
      assessmentSupportDocument_loading,
      assessmentSupportDocument_list,
      assessmentSupportDocument_CLEAR_LIST,
      assessmentSupportDocument_fetchList: fetchList,
      assessmentSupportDocument_downloadDocument: downloadDocument,
    },
  } = useStores()

  /**
   * @description Fetch assessment support document list
   *
   * @param {IAssessmentSupportDocumentGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentSupportDocument_fetchList = useCallback(
    (payload: IAssessmentSupportDocumentGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchList],
  )

  /**
   * @description Download assessment support document, document
   *
   * @param {IAssessmentSupportDocumentDownloadDocumentAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentSupportDocument_downloadDocument = useCallback(
    (payload: IAssessmentSupportDocumentDownloadDocumentAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        downloadDocument({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [downloadDocument],
  )

  return {
    assessmentSupportDocument_loading,
    assessmentSupportDocument_list,
    assessmentSupportDocument_CLEAR_LIST,
    assessmentSupportDocument_fetchList,
    assessmentSupportDocument_downloadDocument,
  }
}

export { useAssessmentSupportDocument }
